import { render } from "./IncomesOtherBodyCz.vue?vue&type=template&id=0bd37996&scoped=true"
import script from "./IncomesOtherBodyCz.vue?vue&type=script&lang=js"
export * from "./IncomesOtherBodyCz.vue?vue&type=script&lang=js"

import "./IncomesOtherBodyCz.vue?vue&type=style&index=0&id=0bd37996&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd37996"]])

export default __exports__